export type PkiCertificateInfo = {
  targetDevice: string;
  keyUsage: string;
  keyId: string;
};
